module.exports = __webpack_public_path__ + "static/media/jeno-10.jpeg";